import React from 'react';

export default function ReportFooter({ report, nextTermDate }) {
  const termEndsDate = report?.term?.end_date
    ? new Date(report.term.end_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
    : null;

  return (
    <div className="rc-footer">
      <div className="rc-next-term">
        {termEndsDate && <div><strong>This Term Ends:</strong> {termEndsDate}</div>}
        {nextTermDate
          ? <div><strong>Next Term Begins:</strong> {nextTermDate}</div>
          : <div style={{ color: '#bbb' }}>Next term date not set</div>
        }
      </div>
      <div style={{ textAlign: 'right' }}>
        {(report?.promotion_status === 'promoted' || (!report?.promotion_status && report?.is_promoted)) && (
          <div style={{ color: '#2e7d32', fontWeight: 'bold' }}><strong>Promoted To:</strong> {report.promoted_to_class || 'Next Class'}</div>
        )}
        {report?.promotion_status === 'probation' && (
          <div style={{ color: '#e65100', fontWeight: 'bold' }}><strong>Promoted on Probation To:</strong> {report.promoted_to_class || 'Next Class'}</div>
        )}
        {report?.promotion_status === 'repeat' && (
          <div style={{ color: '#c62828', fontWeight: 'bold' }}><strong>Advised to Repeat:</strong> {report.class?.name || 'Current Class'}</div>
        )}
        {(report?.days_present != null || report?.days_absent != null) && (
          <div>{report?.days_present ?? 0} days present / {report?.days_absent ?? 0} days absent</div>
        )}
      </div>
    </div>
  );
}
